


import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash, FaSave } from "react-icons/fa";
import axios from "axios";
import { useLoader } from '../../../../context/LoaderProvider.jsx';

const Controllmanagmentdata = () => {
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editEmployeeId, setEditEmployeeId] = useState(null);
    const [employees, setEmployees] = useState([]);
    const { showLoader, hideLoader } = useLoader();

    const [form, setForm] = useState({
        name: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        city: "",
        username: "",
        password: "",
        handlingRole: "HEAD",
        roles: [],
        businessModules: [],
        businessVerticals: [],
    });

    const categories = ["HEAD", "FINANCE", "MANAGER", "SUPPORT"];
    const modules = [
        "Home",
        "subscription",
        "Client_Management",
        "Order_Management",
        "user_management",
        "Account_History",
        "Menu_Management",
        "Report_Analysis",
        "Delivery_Management",
        "Care_Management",
        "Settings_Controls",
        "Promotions_Discounts",
    ];

    const roleOptions = [
        { label: "Food_Beverages", value: "FOOD_AND_BEVERAGES" },
        { label: "Catering_Services", value: "CATERINGS_SERVICES" },
        { label: "Fresh_Grocery", value: "LOGISTICS_SUPPLY" },
        { label: "Logistics_Supply", value: "FRESH_GROCERIES" },
    ];

    // Handle form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const toggleRole = (roleValue) => {
        setForm((prevForm) => {
            const currentRoles = prevForm.roles || [];
            const newRoles = currentRoles.includes(roleValue)
                ? currentRoles.filter((r) => r !== roleValue)
                : [...currentRoles, roleValue];
            return { ...prevForm, roles: newRoles };
        });
    };

    const toggleModule = (module) => {
        setForm((prevForm) => {
            const currentModules = prevForm.businessModules || [];
            const newModules = currentModules.includes(module)
                ? currentModules.filter((m) => m !== module)
                : [...currentModules, module];
            return { ...prevForm, businessModules: newModules };
        });
    };

    const fetchEmployees = async () => {
        const parentId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");

        if (!parentId) {
            console.warn("⚠️ No parentId found in localStorage.");
            return;
        }

        if (!token) {
            console.warn("⚠️ No authToken found in localStorage. Please log in again.");
            return;
        }

        try {
            showLoader();
            const res = await axios.get(
                "https://backend.maamaas.com/subscription/api/admins/get/all",
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            // Filter by parentId
            const filtered = res.data.filter(emp => emp.parentId === Number(parentId));
            setEmployees(filtered);
        } catch (err) {
            console.error("❌ Failed to fetch employees:", err);
        } finally {
            hideLoader();
        }
    };

    useEffect(() => {
        fetchEmployees();
    }, []);

    const handleSubmit = async () => {
        const parentId = localStorage.getItem("userId");

        if (!parentId) {
            alert("Authentication failed. Please login again.");
            return;
        }

        // Allowed module names (from backend enum)
        const allowedModules = [
            "Home",
            "subscription",
            "Client_Management",
            "Order_Management",
            "user_management",
            "Account_History",
            "Menu_Management",
            "Report_Analysis",
            "Delivery_Management",
            "Care_Management",
            "Settings_Controls",
            "Promotions_Discounts"
        ];

        // Send only valid modules
        const cleanedModules = (form.businessModules || []).filter(m => allowedModules.includes(m));

        // Backend-aligned payload
        const payload = {
            id: editEmployeeId || 0,
            name: `${form.name}`.trim(),
            email: form.email,
            phoneNumber: form.phoneNumber?.toString() || "",
            businessType: "TECH",
            handlingRole: form.handlingRole || "HEAD",
            termsAccepted: true,
            parentId: Number(parentId),
            enabled: true,
            registerTime: new Date().toISOString(),
            businessModules: cleanedModules.length ? cleanedModules : ["Home"],
            businessVerticals: form.businessVerticals.length ? form.businessVerticals : ["FOOD_AND_BEVERAGES"],
            accountNonLocked: true,
            credentialsNonExpired: true,
            accountNonExpired: true,
        };

        try {
            showLoader();
            if (isEditing && editEmployeeId) {
                const authToken = localStorage.getItem("authToken");
                await axios.put(
                    `https://backend.maamaas.com/subscription/api/admin/update/${editEmployeeId}`,
                    payload,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${authToken}`,
                        },
                    }
                );
                alert("🎉 Employee updated successfully!");
            } else {
                await axios.post(
                    "https://backend.maamaas.com/subscription/api/admin/registration",
                    payload,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "*/*",
                        },
                    }
                );
                alert("🎉 Employee added successfully!");
            }

            // Reset form
            setShowModal(false);
            setForm({
                name: "",
                email: "",
                phoneNumber: "",
                handlingRole: "HEAD",
                businessModules: [],
                businessVerticals: [],
            });
            setIsEditing(false);
            setEditEmployeeId(null);

            fetchEmployees();
        } catch (error) {
            console.error("❌ Failed to submit employee:", error.response?.data || error.message);
            alert("❌ " + (error.response?.data?.message || "Operation failed."));
        } finally {
            hideLoader();
        }
    };

    const handleEdit = (emp) => {
        setIsEditing(true);
        setEditEmployeeId(emp.id);

        setForm({
            name: emp.name || "",
            lastName: emp.lastName || "",
            email: emp.email || "",
            phoneNumber: emp.phoneNumber || "",
            city: emp.city || "",
            username: emp.username || "",
            password: emp.password || "",
            handlingRole: emp.handlingRole || "HEAD",
            roles: emp.roles || [],
            businessModules: emp.businessModules || [],
            businessVerticals: emp.businessVerticals || [],
        });

        setShowModal(true);
    };

    const handleDelete = async (id) => {
        if (!id) return;
        try {
            showLoader();
            const token = localStorage.getItem("authToken");
            await axios.delete(
                `https://backend.maamaas.com/subscription/api/admin/delete/${id}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            alert("✅ Employee deleted successfully.");
            setEmployees(prev => prev.filter(emp => emp.id !== id));
        } catch (err) {
            console.error("Delete failed:", err);
            alert("❌ Delete failed.");
        } finally {
            hideLoader();
        }
    };

    return (
        <div className="billingswaraper row" >
            <div className="col-lg-10" style={{ overflowY: 'auto', height: 'calc(100vh - 135px)' }}>
                <button
                    onClick={() => {
                        setShowModal(true);
                        setIsEditing(false);
                        setForm({
                            name: "",
                            lastName: "",
                            email: "",
                            phoneNumber: "",
                            city: "",
                            username: "",
                            password: "",
                            handlingRole: "HEAD",
                            roles: [],
                            businessModules: [],
                            businessVerticals: [],
                        });
                    }}
                    style={addButtonStyle}
                >
                    Add+
                </button>

                <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "-10px" }}>
                    <thead>
                        <tr>
                            <th style={thStyle}>#</th>
                            <th style={thStyle}>Name</th>
                            <th style={thStyle}>Email</th>
                            <th style={thStyle}>Mobile</th>
                            <th style={thStyle}>Role</th>
                            <th style={thStyle}>businessVerticals</th>
                            <th style={thStyle}>Modules</th>
                            <th style={thStyle}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {employees.map((emp, i) => (
                            <tr key={emp.id || i} style={i % 2 === 0 ? evenRow : oddRow}>
                                <td style={tdStyle}>{i + 1}</td>
                                <td style={tdStyle}>{emp.name} {emp.lastName}</td>
                                <td style={tdStyle}>{emp.email}</td>
                                <td style={tdStyle}>{emp.phoneNumber}</td>
                                <td style={tdStyle}>{emp.businessType}</td>
                                <td style={tdStyle}>
                                    {Array.isArray(emp.businessVerticals) && emp.businessVerticals.length > 0
                                        ? emp.businessVerticals.join(", ")
                                        : "-"}
                                </td>
                                <td style={tdStyle}>
                                    {Array.isArray(emp.businessModules) ? emp.businessModules.map((m, idx) => <div key={idx}>{m}</div>) : "-"}
                                </td>
                                <td style={tdStyle}>
                                    <button
                                        onClick={() => handleEdit(emp)}
                                        style={deleteButtonStylee}
                                    >
                                        <FaEdit />
                                    </button>
                                    <button onClick={() => handleDelete(emp.id)} style={deleteButtonStyle}>
                                        <FaTrash />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {showModal && (
                    <div style={modalOverlay}>
                        <div style={modalContent}>
                            <h3>{isEditing ? "Edit Employee" : "Add Employee"}</h3>

                            <input type="text" name="name" placeholder="Name" value={form.name} onChange={handleChange} style={inputStyle} />
                            <input type="email" name="email" placeholder="Email" value={form.email} onChange={handleChange} style={inputStyle} />
                            <input type="text" name="phoneNumber" placeholder="Phone Number" value={form.phoneNumber} onChange={handleChange} style={inputStyle} />

                            <div>
                                <label>Bussiness Type:</label><br />
                                {roleOptions.map(({ label, value }) => (
                                    <label key={value} style={checkboxLabel}>
                                        <input type="checkbox" checked={form.roles.includes(value)} onChange={() => toggleRole(value)} />
                                        {label}
                                    </label>
                                ))}
                            </div>

                            <div style={{ marginTop: "10px" }}>
                                <label>Role:</label>
                                <select name="handlingRole" value={form.handlingRole} onChange={handleChange} style={inputStyle}>
                                    {categories.map(c => <option key={c} value={c}>{c}</option>)}
                                </select>
                            </div>

                            <div style={{ marginTop: "10px" }}>
                                <label>Modules:</label>
                                {modules.map(m => (
                                    <label key={m} style={checkboxLabel}>
                                        <input type="checkbox" checked={form.businessModules.includes(m)} onChange={() => toggleModule(m)} />
                                        {m.replace(/_/g, " ")}
                                    </label>
                                ))}
                            </div>

                            <div style={{ marginTop: "20px", textAlign: "right" }}>
                                <button style={saveButton} onClick={handleSubmit}>
                                    {isEditing ? "Update" : "Add"} Employee
                                </button>
                                <button onClick={() => setShowModal(false)} style={cancelButton}>Cancel</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

// Styles
const thStyle = {
    border: "1px solid #ccc",
    backgroundColor: "#b15cd6",
    color: "#fff",
    padding: "2px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
};

const tdStyle = {
    border: "1px solid #ccc",
    textAlign: "center",
    padding: "2px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "97px",
    boxSizing: "border-box"
};

const evenRow = { backgroundColor: "#f9f9f9" };
const oddRow = { backgroundColor: "#fff" };
const inputStyle = { width: "100%", margin: "5px 0", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" };
const addButtonStyle = { marginBottom: "15px", padding: "2px", backgroundColor: "#b15cd6", color: "#fff", border: "none", borderRadius: "4px", fontWeight: "bold" };
const saveButton = { backgroundColor: "#4CAF50", color: "#fff", border: "none", borderRadius: "4px", marginRight: "10px" };
const cancelButton = { backgroundColor: "#ccc", color: "#fff", border: "none", borderRadius: "4px" };
const deleteButtonStyle = { backgroundColor: "#f44336", border: "none", color: "white", borderRadius: "4px", cursor: "pointer", marginRight: "10px" };
const deleteButtonStylee = { backgroundColor: "blue", border: "none", color: "white", borderRadius: "4px", cursor: "pointer", marginRight: "10px" };
const modalOverlay = {
    position: "fixed",
    top: 35,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "9999"
};
const modalContent = {
    backgroundColor: "#fff",
    padding: "24px",
    borderRadius: "12px",
    width: "100%",
    maxWidth: "500px",
    maxHeight: "90vh",
    overflowY: "auto",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
    display: "flex",
    flexDirection: "column",
    gap: "16px"
};

const checkboxLabel = {
    marginRight: "10px",
    display: "inline-block"
};

export default Controllmanagmentdata;